export const noAccent = (text) => {
    var accents    = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
    text = text.split('');
    var strLen = text.length;
    var i, x;
    for (i = 0; i < strLen; i++) {
      if ((x = accents.indexOf(text[i])) !== -1) {
        text[i] = accentsOut[x];
      }
    }
    return text.join('');
}


